import { Check, Loader } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '~/components/ui/card'
import { Input } from '~/components/ui/input'
import { tourAnchor } from '~/helpers/tour/anchors'

type IProps = {
  url: string
  enabled: boolean
  onChange: (next: { url: string, enabled: boolean }) => void
  onSave: () => void
  saving: boolean
}

/** L'adresse qui reçoit les appels, et l'interrupteur des envois (#5). Rien ne s'applique avant « Enregistrer ». */
function WebhookEndpointCard({ url, enabled, onChange, onSave, saving }: IProps) {
  const { t } = useTranslation()

  return (
    <Card {...tourAnchor('webhooks.endpoint')}>
      <CardHeader>
        <CardTitle>{t('webhooks.endpoint.title')}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        <div className="flex flex-col gap-1.5">
          <label className="text-sm font-medium" htmlFor="webhook-url">{t('webhooks.endpoint.url')}</label>
          <Input
            id="webhook-url"
            type="url"
            inputMode="url"
            placeholder="https://"
            value={url}
            onChange={e => onChange({ url: e.target.value, enabled })}
          />
          <p className="text-xs text-muted-foreground">{t('webhooks.endpoint.urlHelp')}</p>
        </div>
        <label className="flex cursor-pointer items-center gap-2 text-sm">
          <input type="checkbox" checked={enabled} onChange={e => onChange({ url, enabled: e.target.checked })} />
          {t('webhooks.endpoint.enabled')}
        </label>
        <div className="flex justify-end">
          <Button onClick={onSave} disabled={saving || !url.trim()} {...tourAnchor('webhooks.save')}>
            {saving ? <Loader className="mr-2 size-4 animate-spin" /> : <Check className="mr-2 size-4" />}
            {t('common.save')}
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}

export default WebhookEndpointCard
